import { BadgeCheck, ShieldCheck, Ticket, Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

const icons = [BadgeCheck, ShieldCheck, Ticket, Clock];

export const Certifications = () => {
  const { t } = useLang();
  const c = t.certifications;
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="certifications-section">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <SectionHead label={c.label} title={c.title} center />
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {c.items.map((it, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div className="card p-7 h-full text-center hover:-translate-y-1 hover:shadow-[0_16px_40px_-20px_rgba(0,0,0,0.18)]" data-testid={`cert-${i}`}>
                  <span className="mx-auto w-14 h-14 rounded-2xl bg-tricolor-green/10 text-tricolor-green flex items-center justify-center">
                    <Icon size={26} />
                  </span>
                  <h3 className="mt-5 font-display font-bold text-lg text-ink">{it.title}</h3>
                  <p className="mt-2 text-sm text-muted leading-relaxed">{it.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
